import { RetrievalResponse } from "../api/retrievalTyped/Retrieval";
import { settings } from "../kernel/Settings";
export class RetrievalApi {
    constructor(restClient) {
        this.restClient = restClient;
    }
    async query(query, userId, top = 10) {
        const authorType = settings.ENV === "production" ? "production" : "staging";
        const res = await this.restClient.post("/be/retrieval/query", {
            queries: [
                {
                    filter: {
                        top_k: top,
                        author: `${authorType}/${userId}`,
                        source: "chat",
                    },
                    query: query,
                },
            ],
        });
        res.validate();
        return res.toModelFromType(RetrievalResponse);
    }
}
